import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class GroupService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getAllGroup(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'reportmaster/getgroup').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getGroup(id: number,isMaintenance:boolean=true): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `reportmaster/getgroupbyid?id=${id}&isMaintenance=${isMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  createGroup(group: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'reportmaster/creategroup', group).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateGroup(group: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'reportmaster/updategroup', group).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `reportmaster/deletegroup?id=${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  authorise(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'reportmaster/authorisegroup', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getFilteredGroup(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'reportmaster/reportgroupfilter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

}
